import { environment } from '../../../environments/environment';

export const URLENTITIES = [
  {
    name: 'Sedes electrónicas',
    url: `${environment.urlBiblioteca}recurso/integro/sedes-electr%C3%B3nicas-/dos/11`,
  },
  {
    name: 'Portales transversales',
    url: `${environment.urlBiblioteca}recurso/integro/portales-transversales/dos/16`,
  },
  {
    name: 'Trámites y servicios',
    url: `${environment.urlBiblioteca}recurso/integro/tr%C3%A1mites-y-servicios/dos/5`,
  },
  {
    name: 'Ventanillas únicas',
    url: `${environment.urlBiblioteca}recurso/integro/ventanillas-%C3%BAnicas/dos/15`,
  },
  {
    name: 'Interoperabilidad',
    url: `${environment.urlBiblioteca}recurso/integro/interoperabilidad/dos/34`,
  },
  {
    name: 'Autenticación Digital',
    url: `${environment.urlBiblioteca}recurso/integro/autenticaci%C3%B3n-digital/dos/32`,
  },
];
